export const handoverPackDisableMessage =
  'The Statement of Advice section needs to be completed prior to generating a Handover Pack. Please review.';
